import { useContext } from 'react';
import SettingsContext from '@contexts/Setting/SettingsContext';

const useSettings = () => useContext(SettingsContext);

export default useSettings;
